import React from "react";
import { Link } from "@inertiajs/inertia-react";
import CustomerLayout from "../../../Layouts/CustomerLayout";

const statusStyles = {
  open: "bg-green-100 text-green-800",
  matched: "bg-blue-100 text-blue-800",
  closed: "bg-gray-100 text-gray-800",
  cancelled: "bg-red-100 text-red-800",
};

const Index = ({ requests }) => (
  <CustomerLayout title="My Requests">
    <div className="mt-6">
      {requests.length === 0 ? (
        <div className="text-center py-12 border-2 border-dashed border-gray-300 rounded-lg">
          <p className="text-sm text-gray-500">
            You haven&apos;t made any requests yet.
          </p>
          <Link
            href="/domestic/requests/new"
            className="mt-3 inline-flex rounded-md bg-orange-600 py-2 px-4 text-sm font-medium text-white hover:bg-orange-700"
          >
            Submit your first request
          </Link>
        </div>
      ) : (
        <ul className="divide-y divide-gray-200 rounded-md border border-gray-200 bg-white">
          {requests.map((r) => (
            <li key={r.id}>
              <Link
                href={`/domestic/requests/${r.id}`}
                className="block px-4 py-4 hover:bg-gray-50"
              >
                <div className="flex items-center justify-between">
                  <p className="truncate text-sm font-medium text-gray-900">
                    {r.trades.join(", ")}
                    {r.postcode_district_code
                      ? ` — ${r.postcode_district_code}`
                      : ""}
                  </p>
                  <div className="ml-2 flex flex-shrink-0 items-center gap-3">
                    <span className="text-xs text-gray-500">
                      {r.response_count}{" "}
                      {r.response_count === 1 ? "response" : "responses"}
                    </span>
                    <span
                      className={`inline-flex rounded-full px-2 text-xs font-semibold leading-5 ${
                        statusStyles[r.status] || statusStyles.closed
                      }`}
                    >
                      {r.status}
                    </span>
                  </div>
                </div>
                <p className="mt-1 truncate text-sm text-gray-500">
                  {r.description}
                </p>
                <p className="mt-1 text-xs text-gray-400">
                  Submitted {r.created_at}
                  {r.ideal_start_date
                    ? ` · Ideal start ${r.ideal_start_date}`
                    : ""}
                </p>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  </CustomerLayout>
);

export default Index;
